var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChatIcon',{on:{"toggle-popup":_vm.togglePopup}}),_c('ChatPopup',{attrs:{"isOpen":!_vm.globalData.isPopupOpen},on:{"close-popup":_vm.togglePopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }